import { PureComponent } from "react";

import SwitchingTitleComponent from "./switching-title/switching-title-component";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";

import classnames from "classnames";
import LottieAnimationComponent from "/components/segments/lottie-animtaion/lottie-animation-component";
import { withAbTests } from "/contexts/ab-tests-context";

import { componentStyles } from "./switching-title-with-signup-component.scss";

const SUBTITLE_MODE_CLASS = {
  ["mobile"]: "mobile-only",
  ["desktop"]: "desktop-only"
};

class SwitchingTitleWithSignupComponent extends PureComponent {
  render() {
    const {
      title,
      mobileTitle,
      switchingWords,
      subtitle,
      signupForm,
      activeIndex,
      showSignup,
      showSubtitle,
      aboveTheFold,
      abTests
    } = this.props;
    const subtitleModeClass = SUBTITLE_MODE_CLASS[showSubtitle];

    let signupFormExt = signupForm;
    if (aboveTheFold) {
      signupFormExt = { ...signupForm, showDecorations: false };
    }

    return (
      <div className={classnames("switching-title-with-signup-component", { "above-the-fold": aboveTheFold })}>
        <div className={classnames("switching-title-wrapper", `subtitle-${subtitleModeClass}`)}>
          <SwitchingTitleComponent
            title={title}
            switchingWords={switchingWords}
            activeIndex={activeIndex}
            mobileTitle={mobileTitle}
            aboveTheFold={aboveTheFold}
          />
        </div>

        <div className={classnames("subtitle-wrapper", subtitleModeClass)}>
          <h2 dangerouslySetInnerHTML={{ __html: subtitle }} />
        </div>

        {showSignup && (
          <div className="signup-form-with-decorations-wrapper">
            <SignupFormComponent {...signupFormExt} placement={"switching_words_title"} focusOnLoad={true} />
          </div>
        )}

        {aboveTheFold && (
          <div className="arrow-wrapper">
            <LottieAnimationComponent aboveTheFold={true} />
          </div>
        )}
        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}

export default withAbTests(SwitchingTitleWithSignupComponent);

SwitchingTitleWithSignupComponent.defaultProps = {
  title: "A great way to manage your",
  mobileTitle: "A great way to manage your <brand-blue>work</end>",
  subtitle: "Plan, organize and track your work. All in one visual collaborative place",
  switchingWords: {
    wordWidth: "124px",
    words: [
      {
        text: "work",
        color: "brand-red"
      },
      {
        text: "team",
        color: "brand-green"
      },
      {
        text: "leads",
        color: "brand-yellow"
      },
      {
        text: "jobs",
        color: "brand-iris"
      }
    ],
    animationInterval: "1000"
  },
  showSignup: true,
  signupForm: {}
};
